(() => {
  let dialog, grid, count, search, opener, pendingFrame, catalogRequest;
  let openRevision = 0;
  let mobileScrollLock;
  function lockMobilePage() {
    if (mobileScrollLock || !matchMedia('(max-width:700px)').matches) return;
    const body = document.body;
    mobileScrollLock = {y:window.scrollY, position:body.style.position, top:body.style.top, width:body.style.width};
    body.style.position = 'fixed';
    body.style.top = `-${mobileScrollLock.y}px`;
    body.style.width = '100%';
  }
  function unlockMobilePage() {
    if (!mobileScrollLock) return;
    const saved = mobileScrollLock;
    mobileScrollLock = null;
    Object.assign(document.body.style, {position:saved.position, top:saved.top, width:saved.width});
    const root = document.documentElement;
    const behavior = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, saved.y);
    root.style.scrollBehavior = behavior;
  }
  function syncButtons(open) {
    document.querySelectorAll('.mega-menu > summary').forEach(button => {
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-haspopup', 'dialog');
      button.classList.toggle('pb-catalog-active', open);
      button.parentElement.open = false;
    });
  }
  function update() {
    const query = search.value.trim().toLowerCase();
    let total = 0;
    [...grid.children].forEach(tile => {
      const name = tile.querySelector('strong')?.textContent || tile.textContent;
      tile.hidden = !name.toLowerCase().includes(query);
      if (!tile.hidden) total++;
    });
    count.textContent = total + ' games found';
  }
  async function openCatalog(trigger) {
    const revision = ++openRevision;
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'pb-game-dialog';
      dialog.setAttribute('aria-label', 'Game catalog');
      dialog.innerHTML = '<div class="pb-game-dialog-header"><h2>Find your next game.</h2><button type="button" aria-label="Close game catalog"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg></button></div><input type="search" aria-label="Search all games" placeholder="Search by game name…"><p aria-live="polite"></p><div class="pb-compact-games"></div>';
      document.body.append(dialog);
      grid = dialog.querySelector('.pb-compact-games');
      count = dialog.querySelector('p');
      search = dialog.querySelector('input');
      search.addEventListener('input', () => {
        cancelAnimationFrame(pendingFrame);
        pendingFrame = requestAnimationFrame(update);
      });
      dialog.querySelector('button').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', e => {
        if (e.target !== dialog) return;
        const b = dialog.getBoundingClientRect();
        if (e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        unlockMobilePage();
        syncButtons(false);
        if (opener?.isConnected) opener.focus({preventScroll:true});
      });
    }
    opener = trigger;
    search.value = '';
    syncButtons(true);
    if (!dialog.open) {
      lockMobilePage();
      dialog.showModal();
    }
    // Keep the phone keyboard closed so it doesn't cover the game list.
    if (matchMedia('(max-width:700px)').matches) {
      dialog.querySelector('button').focus({preventScroll:true});
    } else {
      search.focus({preventScroll:true});
    }
    let source = document.querySelector('[data-pb-catalog] > .pb-compact-games');
    if (!source?.querySelector('a')) {
      grid.replaceChildren();
      count.textContent = 'Loading games…';
      grid.setAttribute('aria-busy', 'true');
      try {
        const home = document.querySelector('[data-tile-game-menu]')?.dataset.homeUrl || window.Shopify?.routes?.root || '/';
        catalogRequest ||= fetch(home, {credentials:'same-origin'})
          .then(response => { if (!response.ok) throw new Error('Catalog unavailable'); return response.text(); })
          .then(html => {
            const catalog = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pb-catalog] > .pb-compact-games');
            if (!catalog?.querySelector('a')) throw new Error('Catalog unavailable');
            return catalog;
          }).catch(error => { catalogRequest = null; throw error; });
        source = await catalogRequest;
      } catch {
        if (revision !== openRevision) return;
        count.textContent = 'Could not load games. Please close and reopen to try again.';
        grid.removeAttribute('aria-busy');
        return;
      }
    }
    if (revision !== openRevision) return;
    grid.replaceChildren();
    source.querySelectorAll(':scope > a').forEach(tile => {
      const copy = tile.cloneNode(true);
      copy.hidden = false;
      copy.removeAttribute('data-shopify-editor-block');
      copy.removeAttribute('id');
      grid.append(copy);
    });
    grid.removeAttribute('aria-busy');
    update();
  }

  document.addEventListener('click', e => {
    const trigger = e.target.closest('.mega-menu > summary,.pb-catalog-browse,.pb-catalog-end a');
    if (!trigger) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openCatalog(trigger);
  }, true);
  syncButtons(false);
  document.addEventListener('shopify:section:load', () => syncButtons(Boolean(dialog?.open)));
})();
